import { useCallback, useEffect, useState } from 'react';
import { supabase } from '@/lib/supabaseClient';
import { useAuth } from '@/context/AuthContext';

// Loads the current user's entitlements once per session and exposes
// hasAccess(product_key). Free tier = logged in with zero matching
// entitlements. Call refresh() after a purchase to close the minute-or-two
// gap before the Systeme.io webhook lands.
export function useEntitlements() {
  const { user } = useAuth();
  const [entitlements, setEntitlements] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!user) {
      setEntitlements([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const { data, error } = await supabase
      .from('entitlements')
      .select('product_key, expires_at')
      .eq('user_id', user.id);

    if (!error && data) {
      const now = Date.now();
      const active = data.filter((e) => !e.expires_at || new Date(e.expires_at).getTime() > now);
      setEntitlements(active.map((e) => e.product_key));
    }
    setLoading(false);
  }, [user]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const hasAccess = useCallback(
    (productKey) => entitlements.includes(productKey),
    [entitlements]
  );

  return { entitlements, hasAccess, loading, refresh };
}
